import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class CardSubtaskService {
  url :string = environment.url;

  constructor(private http :HttpClient) {}

  getDesignSubtasks(designId :number) :Observable<any> {
    return this.http.get(`${this.url}/product_designs/${designId}/subtasks`, {});
    // return of({});
  }

  updateSubtaskOrders(designId :number, payload :any) {
    return this.http.put(
      `${this.url}/product_designs/${designId}/subtasks`,
      payload,
    );
  }

  saveSubtask(designId :number, payload :any) :Observable<any> {
    return this.http.post(
      `${this.url}/product_designs/${designId}/subtasks`,
      payload,
    );
    // return of({});
  }

  deleteAttachment(subtaskId :number, attachmentId :number) :Observable<any> {
    return this.http.delete(
      `${this.url}/product_designs/subtasks/${subtaskId}/attachments/${attachmentId}`,
    );
  }

  deleteSubtask(designId :number, subtaskId :number) :Observable<any> {
    // return of({});
    return this.http.delete(
      `${this.url}/product_designs/${designId}/subtasks/${subtaskId}`,
    );
  }

  toggleCheckSubtask(
    designId :number,
    subtaskId :number,
    payload :any,
  ) :Observable<any> {
    return this.http.put(
      `${this.url}/product_designs/${designId}/subtasks/${subtaskId}`,
      payload,
    );
  }

  getTemplates() {
    return this.http.get(`${this.url}/product_designs/subtasks/templates`, {});
  }

  saveAsTemplate(payload :any) {
    return this.http.post(
      `${this.url}/product_designs/subtasks/templates`,
      payload,
    );
  }

  bulkAddSubtasks(designId, payload :any) {
    return this.http.post(
      `${this.url}/product_designs/${designId}/subtasks/insert`,
      payload,
    );
  }
}
